import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
interface FormulaElement {
  id: string;
  title: string;
  subtitle: string;
  angle: number;
}
const formulaElements: FormulaElement[] = [{
  id: 'promotion',
  title: 'PROMOTION',
  subtitle: 'КОМУНІКАЦІЯ',
  angle: 90
}, {
  id: 'proposition',
  title: 'PROPOSITION',
  subtitle: 'ОФЕР',
  angle: 45
}, {
  id: 'product',
  title: 'PRODUCT',
  subtitle: 'ПРОДУКТ',
  angle: 0
}, {
  id: 'price',
  title: 'PRICE',
  subtitle: 'ЦІНА',
  angle: -45
}, {
  id: 'place',
  title: 'PLACE',
  subtitle: 'МІСЦЕ ПРОДАЖУ',
  angle: -90
}, {
  id: 'physical',
  title: 'PHYSICAL',
  subtitle: 'ВІЗУАЛЬНІ ДОКАЗИ',
  angle: -135
}, {
  id: 'process',
  title: 'PROCESS',
  subtitle: 'ШЛЯХ КЛІЄНТА',
  angle: 180
}, {
  id: 'people',
  title: 'PEOPLE',
  subtitle: 'КОМАНДА ПРОДАЖУ',
  angle: 135
}];
export function FormulaSection() {
  const [activeElement, setActiveElement] = useState<string>('physical');
  const [hoveredElement, setHoveredElement] = useState<string | null>(null);
  const getPosition = (angle: number, radius: number) => {
    const radian = angle * Math.PI / 180;
    return {
      x: Math.cos(radian) * radius,
      y: -Math.sin(radian) * radius
    };
  };
  return <Section className="bg-transparent py-12 md:py-24" data-id="element-193">
      <div className="text-center mb-8 md:mb-16 px-3" data-id="element-194">
        <h2 className="text-xl sm:text-2xl md:text-5xl font-bold mb-3 md:mb-6" data-id="element-195">
          Growth Acquisition Formula
        </h2>
        <p className="text-sm md:text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-196">
          Система з{' '}
          <span className="text-blue-400 font-semibold" data-id="element-197">
            8 управлінських рівнів
          </span>{' '}
          і{' '}
          <span className="text-blue-400 font-semibold" data-id="element-198">понад 200 рішень</span>,
          які впливають на залучення клієнтів
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center px-3" data-id="element-199">
        {/* Left - Interactive Circular Diagram */}
        <div className="relative flex items-center justify-center order-2 lg:order-1" data-id="element-200">
          <div className="relative w-[300px] h-[300px] sm:w-[340px] sm:h-[340px] md:w-[500px] md:h-[500px]" data-id="element-201">
            {/* Outer circle */}
            <div className="absolute inset-0 rounded-full border border-blue-500/20" data-id="element-202"></div>

            {/* Middle circle */}
            <div className="absolute inset-[15%] rounded-full border border-blue-500/30 bg-blue-900/10" data-id="element-203"></div>

            {/* Inner circle with formula */}
            <div className="absolute inset-[30%] rounded-full border border-blue-500/40 bg-[#12103d]/80 backdrop-blur-sm flex items-center justify-center z-10" data-id="element-204">
              <div className="text-center px-2 md:px-4" data-id="element-205">
                <p className="text-blue-400 font-medium text-[10px] md:text-sm mb-1 md:mb-2" data-id="element-206">
                  Макрорівень
                </p>
                <div className="text-[8px] sm:text-[10px] md:text-sm text-gray-300 font-mono leading-relaxed" data-id="element-207">
                  <p data-id="element-208">Ac = P₁·a + P₂·b</p>
                  <p data-id="element-209">+ P₃·c + P₄·d</p>
                  <p data-id="element-210">+ P₅·e + P₆·f</p>
                  <p data-id="element-211">+ P₇·g + P₈·h</p>
                </div>
              </div>
            </div>

            {/* Connecting lines - rendered FIRST (behind buttons) */}
            <svg className="absolute inset-0 w-full h-full pointer-events-none z-0" viewBox="0 0 100 100" data-id="element-212">
              {formulaElements.map(element => {
              const outerPos = getPosition(element.angle, 42);
              const innerPos = getPosition(element.angle, 20);
              const isActive = activeElement === element.id;
              const isHovered = hoveredElement === element.id;
              return <line key={element.id} x1={50 + innerPos.x} y1={50 + innerPos.y} x2={50 + outerPos.x} y2={50 + outerPos.y} stroke={isActive || isHovered ? '#3B82F6' : '#1E3A5F'} strokeWidth="0.3" data-id="element-213" />;
            })}
            </svg>

            {/* Formula Elements - rendered AFTER lines (on top) */}
            {formulaElements.map(element => {
            const pos = getPosition(element.angle, 42);
            const isActive = activeElement === element.id;
            const isHovered = hoveredElement === element.id;
            return <button key={element.id} onClick={() => setActiveElement(element.id)} onMouseEnter={() => setHoveredElement(element.id)} onMouseLeave={() => setHoveredElement(null)} className={`absolute transform -translate-x-1/2 -translate-y-1/2 px-1.5 py-1 sm:px-2 sm:py-1.5 md:px-3 md:py-2 rounded-md md:rounded-lg transition-all duration-300 text-center min-w-[60px] sm:min-w-[75px] md:min-w-[100px] z-20 ${isActive ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/50' : isHovered ? 'bg-[#12103d] border border-blue-400 text-white shadow-lg shadow-blue-500/40' : 'bg-[#12103d]/80 backdrop-blur-sm border border-white/20 text-white hover:border-blue-500/50'}`} style={{
              left: `${50 + pos.x}%`,
              top: `${50 + pos.y}%`
            }} data-id="element-214">
                  <div className="font-bold text-[8px] sm:text-[10px] md:text-sm" data-id="element-215">
                    {element.title}
                  </div>
                  <div className={`text-[6px] sm:text-[8px] md:text-xs ${isActive ? 'text-blue-100' : isHovered ? 'text-blue-300' : 'text-gray-400'}`} data-id="element-216">
                    {element.subtitle}
                  </div>
                </button>;
          })}
          </div>
        </div>

        {/* Right - Info Cards */}
        <div className="space-y-4 md:space-y-6 order-1 lg:order-2" data-id="element-217">
          {/* Top cards */}
          <div className="grid grid-cols-2 gap-3 md:gap-4" data-id="element-218">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-[#1a1045]/60 backdrop-blur-sm border border-purple-500/30 rounded-lg md:rounded-xl p-3 md:p-6" data-id="element-219">
              <h3 className="text-blue-400 font-bold text-sm md:text-xl mb-1 md:mb-2" data-id="element-220">
                ACQUISITION
              </h3>
              <p className="text-gray-400 text-[10px] md:text-sm" data-id="element-221">
                система залучення клієнтів
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#1a1045]/60 backdrop-blur-sm border border-purple-500/30 rounded-lg md:rounded-xl p-3 md:p-6" data-id="element-222">
              <h3 className="text-blue-400 font-bold text-sm md:text-xl mb-1 md:mb-2" data-id="element-223">
                GROWTH
              </h3>
              <p className="text-gray-400 text-[10px] md:text-sm" data-id="element-224">
                кероване зростання бізнесу
              </p>
            </motion.div>
          </div>

          {/* Description */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-gray-300 text-sm md:text-lg leading-relaxed" data-id="element-225">
            Запатентована формула Armar Solutions для створення маркетингових
            гіпотез через систему мікроелементів — факторів, що впливають на
            ефективність залучення.
          </motion.p>

          {/* Understanding box */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-gradient-to-r from-purple-900/30 to-blue-900/20 border border-purple-500/20 rounded-lg md:rounded-xl p-4 md:p-6" data-id="element-226">
            <h4 className="font-bold text-sm md:text-lg mb-3 md:mb-4" data-id="element-227">
              Це про розуміння:
            </h4>
            <ul className="space-y-2 md:space-y-3" data-id="element-228">
              {['коли залучення клієнтів має сенс', 'коли масштабування є обґрунтованим', 'а коли воно створює ілюзію зростання'].map((item, i) => <li key={i} className="flex items-center gap-2 md:gap-3" data-id="element-229">
                  <div className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-blue-400" data-id="element-230"></div>
                  <span className="text-gray-300 text-xs md:text-base" data-id="element-231">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </Section>;
}